import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{staticClass:"warning-base",attrs:{"value":_vm.$store.state.warning,"timeout":3000,"top":""},on:{"input":_vm.hideWarning}},[_c(VIcon,{staticClass:"mr-3"},[_vm._v("mdi-comment-alert-outline")]),_c('span',[_vm._v(_vm._s(_vm.$store.state.warning))]),_c(VBtn,{attrs:{"text":""},on:{"click":_vm.hideWarning}},[_vm._v("OK")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }